import { AppEnumMap, BasicDataType } from 'src/app/shared/interface/common.interface';
import { EditableWhenRule } from '../../adjustment-grid/interface/adjustment.interface';
import { FileType } from '../../file-viewer/interface/file-viewer.interface';
import { AsyncDataStatusType, PropertyDataSourceType, ValuationType } from '../../order/interface/order.interface';
import { OrderMultiDataSource } from '../../order/interface/value-reconciliation.interface';

/** Identifies which state object holds the property a unit operation targets. */
export type UnitOpScope = 'SUBJECT' | 'SALES_COMPS' | 'COST_COMPS' | 'STR_COMPS' | 'LTR_COMPS';

/** Payload emitted when the comps grid must regenerate after a property's units change. */
export interface GridReloadRequest {
  scope: UnitOpScope;
  propertyId: string;
}

export type PropertyAttribute =
  | StructureAttribute
  | UnitAttribute
  | 'AboveGradeFinishedArea'
  | 'AboveGradeFinishedAreaSource'
  | 'AboveGradeFinishedAreaUnits'
  | 'adjustedPerSquareFeet'
  | 'adjustedPrice'
  | 'adjustedPricePerSquareFeet'
  | 'adjustmentValue'
  | 'aduCount'
  | 'adverseInfluences'
  | 'AgentAddress'
  | 'AgentRemarks'
  | 'allAmenities'
  | 'amenities'
  | 'appeal'
  | 'Appliances'
  | 'ArchitecturalRating'
  | 'AssessedImprovementValue'
  | 'AssessedLandValue'
  | 'AssessedValue'
  | 'AssessedYear'
  | 'AssessorsMapReference'
  | 'AssociationComments'
  | 'AssociationFee'
  | 'AssociationFeeFrequency'
  | 'AssociationFeeIncludes'
  | 'AssociationName'
  | 'AssociationYN'
  | 'AttachedCarport'
  | 'AttachedGarage'
  | 'AttachedGarageYN'
  | 'AttachmentType'
  | 'AverageDailyRent'
  | 'Basement'
  | 'BasementBathroomsFull'
  | 'BasementBathroomsHalf'
  | 'BasementBedrooms'
  | 'BasementEntry'
  | 'BasementOther'
  | 'BasementRating'
  | 'BasementRecRooms'
  | 'BasementType'
  | 'BathroomsTotalInteger'
  | 'BelowGradeFinishedArea'
  | 'BelowGradeFinishedAreaSource'
  | 'BelowGradeFinishedAreaUnits'
  | 'BelowGradeTotalArea'
  | 'BorrowerName'
  | 'BuildingAreaTotal'
  | 'BuildingCondition'
  | 'BuiltInGarage'
  | 'BuyerAgentEmail'
  | 'BuyerAgentFullName'
  | 'BuyerAgentOfficePhone'
  | 'BuyerFinancing'
  | 'BuyerOfficeEmail'
  | 'BuyerOfficeName'
  | 'BuyerOfficePhone'
  | 'Carport'
  | 'CarportSpaces'
  | 'CarportType'
  | 'CarportYN'
  | 'CarStorageRating'
  | 'CarStorageType'
  | 'CensusTractId'
  | 'certification'
  | 'certificationOrg'
  | 'City'
  | 'CleaningFee'
  | 'CloseDate'
  | 'ClosePrice'
  | 'comments'
  | 'componentOwnership'
  | 'Concessions'
  | 'ConcessionsAmount'
  | 'ConcessionsComments'
  | 'conditionComments'
  | 'ConstQuality'
  | 'ConstructionType'
  | 'ContractDate'
  | 'contractDateUnknownYN'
  | 'CoolingType'
  | 'CountyOrParish'
  | 'Covered'
  | 'CoveredSpaces'
  | 'coverImageUrl'
  | 'currentUse'
  | 'CurrentValue'
  | 'DataSource'
  | 'DaysAvailableLast12Months'
  | 'DaysBlockedLast12Months'
  | 'DaysOnMarket'
  | 'DaysReservedLast12Months'
  | 'deckDescription'
  | 'DeckType'
  | 'derived_adjustedMonthlyRent'
  | 'derivedAssociationFeeFrequency'
  | 'derivedAttachmentType'
  | 'derivedBuildingCondition'
  | 'derivedConstQuality'
  | 'derivedCurrentDom'
  | 'derivedLotFeatures'
  | 'derivedNumberOfUnitsTotal'
  | 'derivedTotalDom'
  | 'derivedView'
  | 'DetachedCarport'
  | 'DetachedGarage'
  | 'Distance'
  | 'DistressedYN'
  | 'DistressType'
  | 'Driveway'
  | 'efficiencyRating'
  | 'efficiencyRatingOrg'
  | 'electricitySource'
  | 'ElementarySchool'
  | 'ElementarySchoolDistrict'
  | 'EntryLevel'
  | 'EntryLocation'
  | 'ExteriorFeatures'
  | 'FIPS'
  | 'FireplaceFeatures'
  | 'FireplacesTotal'
  | 'FireplaceYN'
  | 'FlipYN'
  | 'Flooring'
  | 'FloorLocation'
  | 'Foundation'
  | 'FoundationDetails'
  | 'FoundationWalls'
  | 'FunctionalUtility'
  | 'Furnished'
  | 'furnitureCost'
  | 'GarageArea'
  | 'GarageNumber'
  | 'GarageSpaces'
  | 'GarageType'
  | 'GarageYN'
  | 'gasSource'
  | 'GreenEnergyEfficient'
  | 'GreenEnergyGeneration'
  | 'grossAdjustmentValue'
  | 'hasAdverseInfluence'
  | 'HasBasement'
  | 'HeatingFuelType'
  | 'HeatingType'
  | 'HighSchool'
  | 'HighSchoolDistrict'
  | 'hoaDues'
  | 'HostFee'
  | 'ImageURLs'
  | 'InspectionDate'
  | 'InspectionType'
  | 'InspectorEmail'
  | 'InspectorName'
  | 'InspectorPhone'
  | 'inspectorType'
  | 'InteriorFeatures'
  | 'isVandalized'
  | 'LastSaleContractDate'
  | 'LastSaleDate'
  | 'LastSaleDocumentType'
  | 'LastSalePrice'
  | 'LastSaleRecordingDate'
  | 'Latitude'
  | 'leaseEndDate'
  | 'leaseStartDate'
  | 'LegalSubdivisionName'
  | 'Levels'
  | 'ListAgentEmail'
  | 'ListAgentFullName'
  | 'ListAgentPreferredPhone'
  | 'ListedRent'
  | 'ListingContractDate'
  | 'ListingDescription'
  | 'ListingId'
  | 'ListingType'
  | 'ListOfficeEmail'
  | 'ListOfficeName'
  | 'ListOfficePhone'
  | 'ListPrice'
  | 'listPriceChangeDate'
  | 'ListPriceMonthly'
  | 'ListPriceNightly'
  | 'ListPriceWeekly'
  | 'LivingArea'
  | 'LivingAreaSource'
  | 'LivingAreaUnits'
  | 'LocationFactors'
  | 'locationInfluenceComment'
  | 'LocationRating'
  | 'Longitude'
  | 'LotFeatures'
  | 'lotSize'
  | 'LotSizeAcres'
  | 'LotSizeDimensions'
  | 'LotSizeSquareFeet'
  | 'lotSizeUnit'
  | 'MainLevelBathrooms'
  | 'MainLevelBedrooms'
  | 'ManufacturedHouseVINHUDPlates'
  | 'MarketImprovementValue'
  | 'MarketLandValue'
  | 'MarketValue'
  | 'MiddleOrJuniorSchool'
  | 'MiddleOrJuniorSchoolDistrict'
  | 'MlsBoard'
  | 'MLSListingNumber'
  | 'MlsStatus'
  | 'ModificationTimestamp'
  | 'NeighborhoodBuiltUp'
  | 'NeighborhoodGrowth'
  | 'NeighborhoodLocation'
  | 'NumberOfUnitsTotal'
  | 'OccupancyDetermination'
  | 'OccupancyRate'
  | 'occupantType'
  | 'OfficeAddress1'
  | 'OffMarketTimestamp'
  | 'OpenParking'
  | 'OpenParkingSpaces'
  | 'OpenParkingYN'
  | 'OriginalEntryTimestamp'
  | 'OriginalListPrice'
  | 'originalSaleType'
  | 'OriginatingSystemName'
  | 'OtherParking'
  | 'overallRating'
  | 'Owner1FullName'
  | 'Owner2FullName'
  | 'OwnerOccupied'
  | 'OwnershipModel'
  | 'ParcelNumber'
  | 'ParkingFeatures'
  | 'ParkingSpaces'
  | 'ParkingTotal'
  | 'PatioAndPorchFeatures'
  | 'patioDescription'
  | 'PatioType'
  | 'PendingTimestamp'
  | 'PeopleCapacity'
  | 'PhysicalCharacteristicsSource'
  | 'PMXPropertyId'
  | 'PoolFeatures'
  | 'PoolPrivateYN'
  | 'PoolType'
  | 'porchDescription'
  | 'PorchType'
  | 'PostalCode'
  | 'pricePerSquareFeet'
  | 'priorSaleDate'
  | 'priorSalePrice'
  | 'ProjectCommonElements'
  | 'ProjectCommonElementsLeased'
  | 'ProjectCommonElementsRecreation'
  | 'ProjectConversion'
  | 'ProjectConversionDate'
  | 'ProjectDataSourceUnitsInfo'
  | 'projectedUse'
  | 'ProjectFloors'
  | 'ProjectForSaleUnits'
  | 'ProjectHoa'
  | 'ProjectLegalName'
  | 'ProjectMaintenance'
  | 'ProjectMultiDwellingDataSource'
  | 'ProjectMultiDwellingUnits'
  | 'ProjectNumberOfUnitsTotal'
  | 'ProjectPhases'
  | 'ProjectPud'
  | 'ProjectRecreationalFacilities'
  | 'ProjectRecreationComplete'
  | 'ProjectRentalItems'
  | 'ProjectRentedUnits'
  | 'ProjectSoldUnits'
  | 'ProjectStatus'
  | 'ProjectTotalUnits'
  | 'ProjectUnitType'
  | 'PropertyAttachedYN'
  | 'propertyCity'
  | 'propertyImageURLs'
  | 'propertyLatitude'
  | 'propertyLongitude'
  | 'propertyRights'
  | 'propertyState'
  | 'propertyStreetAddress'
  | 'PropertySubType'
  | 'PropertySubTypeDescription'
  | 'PropertyType'
  | 'propertyZip'
  | 'ProximityDirection'
  | 'PublicRemarks'
  | 'renewalEnergyComponent'
  | 'RentalIncome'
  | 'RentalSource'
  | 'RentalSourceUrl'
  | 'RentalType'
  | 'rentConcessions'
  | 'RevenueLast12Months'
  | 'Roof'
  | 'RVParkingDimensions'
  | 'saleType'
  | 'secondaryDataSource'
  | 'SeniorCommunityYN'
  | 'sewer'
  | 'SimilarityScore'
  | 'soldSaleType'
  | 'Source'
  | 'SourcePropertyId'
  | 'SpecialListingConditions'
  | 'StandardStatus'
  | 'StateOrProvince'
  | 'StatusChangeTimestamp'
  | 'Stories'
  | 'StoriesTotal'
  | 'StreetAdditionalInfo'
  | 'StreetAddress'
  | 'StreetDirPrefix'
  | 'StreetDirSuffix'
  | 'StreetName'
  | 'StreetNumber'
  | 'StreetNumberNumeric'
  | 'StreetSuffix'
  | 'StreetSuffixModifier'
  | 'StructureType'
  | 'SubdivisionName'
  | 'subdivisionRating'
  | 'subjectCity'
  | 'SubjectSaleStatus'
  | 'subjectState'
  | 'subjectStreetAddress'
  | 'subjectZip'
  | 'TaxAnnualAmount'
  | 'TaxLegalDescription'
  | 'TaxYear'
  | 'unfinishedAboveGrade'
  | 'UnitNumber'
  | 'UnparsedAddress'
  | 'utilityCost'
  | 'View'
  | 'ViewFactors'
  | 'ViewRating'
  | 'WaterFrontFeatures'
  | 'WaterSource'
  | 'WaterYN'
  | 'weightage'
  | 'YearBuiltEffective'
  | 'Zoning'
  | 'zoningClassification'
  | 'ZoningCompliance'
  | 'ZoningDescription';

/** Fields that belong at the STRUCTURE level */
export type StructureAttribute =
  | 'age'
  | 'ArchitecturalStyle'
  | 'atticType'
  | 'bathFloor'
  | 'bathFloorCondition'
  | 'bathWainscot'
  | 'bathWainscotCondition'
  | 'Cooling'
  | 'CoolingOtherDescription'
  | 'dampnessYN'
  | 'derivedCooling'
  | 'derivedHeating'
  | 'exteriorWalls'
  | 'exteriorWallsCondition'
  | 'floors'
  | 'floorsCondition'
  | 'foundationType'
  | 'foundationWalls'
  | 'foundationWallsCondition'
  | 'guttersDownspouts'
  | 'guttersDownspoutsCondition'
  | 'Heating'
  | 'HeatingOtherDescription'
  | 'infestationYN'
  | 'Roof'
  | 'roofCondition'
  | 'screens'
  | 'screensCondition'
  | 'settlementYN'
  | 'stormSash'
  | 'stormSashCondition'
  | 'StructureType'
  | 'sumpPumpYN'
  | 'trimFinish'
  | 'trimFinishCondition'
  | 'walls'
  | 'wallsCondition'
  | 'windows'
  | 'windowsCondition'
  | 'YearBuilt'
  | 'yearBuiltEstimatedYN';

/** Fields that belong at the UNIT level */
export type UnitAttribute =
  | 'BathroomsDecimal'
  | 'BathroomsFull'
  | 'BathroomsFullCalculated'
  | 'BathroomsHalf'
  | 'BathroomsHalfCalculated'
  | 'bathroomsTotal'
  | 'BedroomsTotal'
  | 'RoomsTotal';

export enum PropertyFieldScope {
  PROPERTY = 'PROPERTY',
  STRUCTURE = 'STRUCTURE',
  UNIT = 'UNIT',
}

export type UnitDetail = {
  [key in UnitAttribute]?: PropertyAttributeValue;
} & {
  id: number;
  name: string;
};

export type StructureDetail = {
  [key in StructureAttribute]?: PropertyAttributeValue;
} & {
  id: number;
  name: string;
  units?: UnitDetail[];
};

export type PropertyDetail = {
  [key in PropertyAttribute]?: PropertyAttributeValue;
};

export enum PropertyRole {
  SUBJECT = 'SUBJECT',
  CUSTOM_SUBJECT = 'CUSTOM_SUBJECT',
  COMPARABLE = 'COMPARABLE',
  CUSTOM_COMPARABLE = 'CUSTOM_COMPARABLE',
  SPECIFIC_COMPARABLE = 'SPECIFIC_COMPARABLE',
}

export type ExtendedPropertyDetail = PropertyDetail & {
  id?: string;
  propertyRole?: PropertyRole;
  valuationType?: ValuationType;
  deedHistory?: PropertyAttributeValue<Array<DeedHistory>>;
  listingHistory?: PropertyAttributeValue<Array<ListingHistory>>;
  imageWithLabels?: PropertyAttributeValue<Array<ImageRecord>>;
  roomDetails?: PropertyAttributeValue<PropertyRoomCharacter>;
  isIdentified?: boolean;
  flood?: PropertyAttributeValue<Flood>;
  plat?: PropertyAttributeValue<Plat>;
  plan?: PropertyAttributeValue<Array<ImageRecord>>;
  scenarioId?: string;
  structures?: StructureDetail[];
  summary?: PropertySummary;
};

/** Pre-aggregated property-level values derived from structures/units by the backend. Read-only for the UI. */
export interface PropertySummary {
  summary_BedroomsTotal?: number | string;
  summary_BathroomsHalf?: number | string;
  summary_BathroomsFullCalculated?: number | string;
  summary_BathroomsHalfCalculated?: number | string;
  summary_YearBuilt?: number | string;
}

export type PropertyFieldConfigMap = {
  [key in PropertyAttribute]: PropertyFieldConfig;
};

export interface ConditionalNumericConstraint {
  when: EditableWhenRule;
  value: number | null;
  default?: number | null;
}

export type NumericConstraintConfig = number | ConditionalNumericConstraint | null;

export interface PropertyFieldConfig {
  fieldDisplayName: string;
  datatype: BasicDataType;
  enumKey: keyof AppEnumMap | null;
  subjectEnumKey: keyof AppEnumMap | null;
  prefix: string | null;
  suffix: string | null;

  /** Indicates whether this field belongs at Property, Structure, or Unit level. Defaults to PROPERTY if not set. */
  scope?: PropertyFieldScope;

  /** In case of derived fields, this will be the list of fields that were used to derive this field's value. */
  referenceFieldList: Array<PropertyAttribute>;

  /** If true, user can enter custom value. Default is false. */
  acceptCustomValue: boolean;

  /** If true, multiple values can be selected from the dropdown. Default is false. */
  isMultiSelect: boolean;

  /** Number of decimal digits to be allowed. Default is 0. */
  maxFractionDigits: number | null;

  /** If isMultiSelect is true, then this will be the max number of selections allowed. */
  maxSelection: number | null;

  /** Number of decimal places to support if the datatype is a number */
  decimalPrecision: number | null;

  /** This prefix will be used for abbreviated field value */
  abbreviationPrefix: string | null;

  /** This suffix will be used for abbreviated field value */
  abbreviationSuffix: string | null;

  /** If true, autoComputed adjustment value will not be used for calculation. Default is false. */
  ignoreAutoAdjustment: boolean;

  /** Enforce max value on input field. May be a number or a conditional constraint. */
  maxValue?: NumericConstraintConfig;

  /** Enforce min value on input field. May be a number or a conditional constraint. */
  minValue?: NumericConstraintConfig;

  /**
   * Enforce max value on input field specifically for subject.
   * If unavailable, uses `maxValue`. May be a number or a conditional constraint.
   */
  subjectMaxValue?: NumericConstraintConfig;

  /**
   * Enforce min value on input field specifically for subject.
   * If unavailable, uses `minValue`. May be a number or a conditional constraint.
   */
  subjectMinValue?: NumericConstraintConfig;

  /** Enforce max character length on text input field */
  maxLength?: number | null;

  /**
   * Enforce max character length specifically for subject.
   * If unavailable, uses `maxLength`.
   */
  subjectMaxLength?: number | null;

  /** Decides the affect of this field's value on the property's value */
  effectOnValue?: 'negative' | 'positive' | null;

  allowNegativeNumber?: boolean;

  /** Rule that locks the field (rendered read-only) when it evaluates false (former `editableWhen`). */
  enabledWhen?: EditableWhenRule;

  /** Rule that makes the field read-only with its value still shown when it evaluates false, like a conditional `isEditable: false`. */
  editableWhen?: EditableWhenRule;
}

export interface PropertyPageView {
  companyKey: string;
  reportType: string;
  pageName: string;
  displayValue?: string;
  showNavMenu?: boolean;
  sectionList: PropertyPageViewSection[];
}

export interface PropertyPageViewSection {
  sectionName: string;
  sectionDisplayName: null | string;
  layoutStructure:
    | 'KEY_VALUE'
    | 'COMPARISON'
    | 'PARAGRAPH'
    | 'ROOM_DESCRIPTION'
    | 'LISTING_HISTORY'
    | 'DEED_HISTORY'
    | 'IMAGE_GRID'
    | 'IMAGE_PLACEHOLDER_GRID'
    | 'PRIOR_SALE'
    | 'LAND_USE_RATIO'
    | 'QUESTIONNAIRE';
  editable?: boolean;
  cssStyleSet?: Record<string, string>;
  cssClassList?: string[];
  showValidation?: boolean;

  /** Absent on a section that only groups other sections; a layout is served as configured. */
  fieldInfoList?: PropertyPageViewField[];
  isTemplate?: boolean;
  templateScope?: PropertyFieldScope;
  structureIndex?: number;
  unitIndex?: number;
  sectionId?: string;
  imageSources?: string[] | null;

  /** Child rows/groups. A section carries either fields or children, never both. */
  sectionList?: PropertyPageViewSection[];
  compareSources?: PropertyDataSourceType[];
}

export interface PropertyPageViewField {
  fieldName: PropertyAttribute;
  editable?: boolean;
  cssStyleSet?: Record<string, string>;
  cssClassList?: string[];
  showValidation?: boolean;
  editor?: PropertyFieldEditor | null;

  /** Per-control label. Overrides the field dictionary's fieldDisplayName when set. */
  label?: string | null;
  dataSource?: PropertyDataSourceType;
}

export enum PropertyFieldEditor {
  description = 'property-description-editor',
  coordinate = 'coordinate-editor',
  lotSize = 'lot-size',
  radioButton = 'radio-button',
}

export enum StandardStatusType {
  active = 'Active',
  activeUC = 'Active Under Contract',
  pending = 'Pending',
  sold = 'Sold',
  canceled = 'Cancel/Withdrawn',
  expired = 'Expired',
  delisted = 'Delisted',
}

export interface PropertyAttributeValue<T = any> {
  adjustmentValue?: OrderMultiDataSource<number | string>;
  listingRecord?: T;
  publicRecord?: T;
  inspectionRecord?: T;
  rentalRecord?: T;
  userRecord?: T;
  avmRecord?: T;
  selectedSource?: PropertyDataSourceType;
  asyncDataStatus?: AsyncDataStatusType | null;

  /** @deprecated */
  format?: BasicDataType;

  /** @deprecated */
  fieldDisplayName: null | string;

  /** @deprecated */
  fieldEnumType: keyof AppEnumMap | null;

  /** @deprecated */
  required: boolean;

  /** @deprecated */
  prefix?: string | null;

  /** @deprecated */
  suffix?: string | null;

  /** @deprecated */
  selectedValue?: string | number | null;
}

export type StructureApiDetail = {
  [key in StructureAttribute]?: PropertyApiAttributeValue;
} & {
  units?: UnitApiDetail[];
};

export type UnitApiDetail = {
  [key in UnitAttribute]?: PropertyApiAttributeValue;
};

export type PropertyApiDetail = {
  [key in PropertyAttribute]?: PropertyApiAttributeValue;
};

export type ExtendedPropertyApiDetail = PropertyApiDetail & {
  id?: string;
  valuationType?: ValuationType;
  deedHistory?: PropertyApiAttributeValue<Array<DeedHistory>>;
  listingHistory?: PropertyApiAttributeValue<Array<ListingHistory>>;
  imageWithLabels?: PropertyApiAttributeValue<Array<ImageRecord>>;
  roomDetails?: PropertyApiAttributeValue<PropertyRoomCharacter>;
  structures?: StructureApiDetail[];
};

export interface PropertyApiAttributeValue<T = any> {
  av: { ue: unknown; ac: unknown };
  lr: T;
  pr: T;
  ir: T;
  rr: T;
  ur: T;
  ss: PropertyApiDataSourceType;
  as: AsyncDataStatusType | null;
}

export type PropertyApiDataSourceType = 'lr' | 'rr' | 'pr' | 'ir' | 'ur';

export interface PropertyHistory {
  Address?: string;
  AgentAddress?: string;
  AlternateListingNumber?: string;
  Appliances?: string;
  ArchitecturalStyle?: string;
  Basement?: string;
  BathroomsDecimal?: string;
  BathroomsTotalInteger?: string;
  bathroomsTotal?: string;
  BedroomsTotal?: string;
  City?: string;
  CloseDate?: Date;
  ClosePrice?: string;
  CommunityFeatures?: string;
  ConstructionMaterials?: string;
  Cooling?: string;
  DataSource?: string;
  DaysOnMarket?: string;
  DistressedYN?: string;
  DistressType?: string;
  ElementarySchool?: string;
  ElementarySchoolDistrict?: string;
  EventTimestamp?: Date;
  ExteriorFeatures?: string;
  FIPS?: string;
  FireplaceFeatures?: string;
  FireplacesTotal?: string;
  FireplaceYN?: string;
  GarageSpaces?: string;
  GarageYN?: string;
  Heating?: string;
  HighSchool?: string;
  HighSchoolDistrict?: string;
  InteriorFeatures?: string;
  Latitude?: string;
  ListAgentEmail?: string;
  ListAgentFullName?: string;
  ListAgentPreferredPhone?: string;
  ListAgentStateLicense?: string;
  ListingContractDate?: string;
  ListingId?: string;
  ListingKey?: string;
  ListingType?: string;
  ListOfficeEmail?: string;
  ListOfficeName?: string;
  ListOfficePhone?: string;
  ListPrice?: string;
  LivingArea?: string;
  Longitude?: string;
  LotFeatures?: string;
  LotSizeDimensions?: string;
  LotSizeSquareFeet?: string;
  MajorChangeTimestamp?: string;
  MiddleOrJuniorSchool?: string;
  MiddleOrJuniorSchoolDistrict?: string;
  MlsBoard?: string;
  MLSListingNumber?: string;
  MlsStatus?: MlsStatusType;
  ModificationTimestamp?: Date;
  OfficeAddress1?: string;
  OffMarketDate?: Date;
  OffMarketTimestamp?: Date;
  OnMarketDate?: string;
  OtherStructures?: string;
  ParcelNumber?: string;
  ParkingFeatures?: string;
  PatioAndPorchFeatures?: string;
  PendingTimestamp?: Date;
  PMXPropertyId?: string;
  PoolFeatures?: string;
  PostalCode?: string;
  PostalCodePlus4?: string;
  PropertyRefID?: string;
  PropertySubType?: string;
  PropertyType?: string;
  PublicRemarks?: string;
  Roof?: string;
  RoomsTotal?: string;
  StandardStatus?: string;
  StateOrProvince?: string;
  StatusChangeTimestamp?: Date;
  StdAddress: {
    City?: string;
    PostalCode?: string;
    StateOrProvince?: string;
    UnparsedAddress?: string;
  };
  StoriesDescription?: string;
  StoriesTotal?: string;
  Topography?: string;
  UnparsedAddress?: string;
  View?: string;
  WaterAccess?: string;
  WaterFrontFeatures?: string;
  WaterSource?: string;
  WaterYN?: string;
  YearBuilt?: string;
  Zoning?: string;
  ZoningDescription?: string;
}

export interface PropertyDeedHistory {
  HawaiiTitleCertificateNumber?: null;
  MailingStreetDirPrefix?: null;
  TitleCompanyName?: string;
  Buyer2IsCorporation?: boolean;
  Buyer1MiddleName?: null;
  MailingStreetDirSuffix?: null;
  TransactionMultiAPN?: null;
  Buyer1CareOfName?: null;
  TransactionDocumentType?: string;
  TransferTax?: string;
  TransactionTypeForeclosure?: boolean;
  Buyer1OwnershipRights?: string;
  TransactionTypeNewConstruction?: boolean;
  Buyer2Relationship?: string;
  Seller2FullName?: string;
  ClosePriceCode?: string;
  Buyer1Relationship?: string;
  TransactionRecordingPage?: null;
  Buyer2MiddleName?: string;
  MailingCity?: string;
  MailingPostalCodePlus4?: string;
  PartialInterestType?: null;
  TransactionContractDate?: Date;
  MailingStreetNumberSuffix?: null;
  MailingUnitPrefix?: null;
  Buyer1LastName?: string;
  TransactionTypeInterFamily?: boolean;
  TransactionRecordingDate?: Date;
  TransactionRecordingBook?: null;
  MailingUnitNumber?: null;
  TransactionTypeResale?: boolean;
  TransactionType?: string;
  Buyer2OwnershipRights?: null;
  Buyer1FirstName?: string;
  Buyer1NameSuffix?: null;
  HaveAdditionalOwners?: boolean;
  ClosePrice?: number;
  Buyer2LastName?: string;
  MailingStreetNumberAddl?: null;
  MailingPostalCode?: string;
  Buyer2FullName?: string;
  Seller1FullName?: string;
  HawaiiLandCourtDocumentId?: null;
  Buyer2FirstName?: string;
  Buyer1FullName?: string;
  MailingStreetNumber?: string;
  AssessorsMapReference?: null;
  WashingtonExciseNumber?: null;
  MailingStreetSuffix?: string;
  MailingStreetName?: string;
  Buyer2NameSuffix?: null;
  MailingStateOrProvince?: string;
  TransactionRecordingDocumentId?: string;
  Seller1IsCorporation?: boolean;
  TransactionTypeREO?: boolean;
  Seller2IsCorporation?: boolean;
  Buyer1IsCorporation?: boolean;
  MailingCarrierRoute?: string;
}

export interface PropertyImage {
  automatedLabel?: string;
  fileName?: string;
  createdDate?: Date;
  isSelected?: boolean;
  fileReferenceId?: string;
  label?: string;
  url?: string;
  fileType?: string;
}

export interface PropertyRoomCharacter {
  RoomLaundryLevel?: string;
  RoomBedroom2Features?: string;
  RoomBedroom4Level?: string;
  RoomLivingRoomLevel?: string;
  RoomLibraryLevel?: string;
  RoomBedroom4Features?: string;
  RoomBedroom5Dimensions?: string;
  RoomBedroom5Features?: string;
  RoomRecreationRoomFeatures?: string;
  RoomKitchenLevel?: string;
  RoomRecreationRoomDimensions?: string;
  RoomFamilyRoomLevel?: string;
  RoomRecreationRoomLevel?: string;
  RoomBreakfastRoomFeatures?: string;
  RoomMasterBedroomLevel?: string;
  RoomLaundryDimensions?: string;
  RoomFamilyRoomFeatures?: string;
  RoomLaundryFeatures?: string;
  RoomLivingRoomDimensions?: string;
  RoomBedroom3Features?: string;
  RoomFamilyRoomDimensions?: string;
  RoomKitchenDimensions?: string;
  RoomBedroom2Dimensions?: string;
  RoomDiningRoomFeatures?: string;
  RoomBreakfastRoomLevel?: string;
  RoomBedroom4Dimensions?: string;
  RoomMasterBedroomDimensions?: string;
  RoomLibraryDimensions?: string;
  RoomDiningRoomLevel?: string;
  RoomMasterBedroomFeatures?: string;
  RoomDiningRoomDimensions?: string;
  RoomLibraryFeatures?: string;
  RoomBedroom3Level?: string;
  RoomLivingRoomFeatures?: string;
  RoomBreakfastRoomDimensions?: string;
  RoomBedroom5Level?: string;
  RoomBedroom2Level?: string;
  RoomKitchenFeatures?: string;
  RoomBedroom3Dimensions?: string;
}

export interface PropertyViewApiRequest {
  [param: string]: string;
  reportType: string;
  pageName: PropertyLayoutType;
}

export type PropertyLayoutType =
  | 'neighborhoodLocality'
  | 'propertyDetails'
  | 'projectInformation'
  | 'subjectDetails'
  | 'subjectPropertyImage'
  | 'comparablePropertyImage'
  | 'comparableDetails'
  | 'propertyCondition';

export interface PropertyViewApiResponse {
  pageLayout: PropertyPageView;
}

export interface PropertyDataApiRequest {
  // [param: string]: string | undefined;
  reportType: string;
  pageName: 'propertyDetails' | 'projectInformation';
  orderId?: string;
  propertyId?: string;
  listingId?: string;
  pmxProperty?: boolean;
  responseKeys?: PropertyAttribute[];
}

export interface PropertySearchCriteria {
  listingsOnly?: string;
  streetNumber?: string;
  streetName?: string;
  unitNumber?: string;
  city?: string;
  state?: string;
  zip?: string;
  fipsCode?: string;
  parcelNumber?: string;
  ownerName?: string;
  mlsNumber?: string;
  mlsBoard?: string;
}

export type MlsStatusType = 'Sold' | 'Active Under Contract' | 'Active' | 'Pending';

export interface ListingHistory {
  isActive: boolean;
  isPriorSale: boolean;
  ListingContractDate?: Date | null;
  ListPrice?: string;
  ClosePrice?: string;
  CloseDate?: Date | null;
  StandardStatus?: string;
  ModificationTimestamp?: Date | null;
  MLSListingNumber?: string;
  MlsBoard?: string;
  ListingId?: string;
  children?: ListingHistoryChild[];
  saleDate?: Date | null;
  EventTimeStamp?: Date | null;
}

type ListingHistoryChild = Omit<ListingHistory, 'isActive' | 'isPriorSale' | 'children' | 'ListingId'>;

export interface DeedHistory {
  isActive: boolean;
  isPriorSale: boolean;
  TransactionRecordingDate?: Date | null;
  TransactionContractDate?: Date | null;
  ClosePrice?: string;
  TransactionDocumentType?: string;
  TransactionRecordingDocumentId?: string;
  Buyer1FullName?: string;
  Buyer2FullName?: string;
  Seller1FullName?: string;
  Seller2FullName?: string;
  children?: DeedHistoryChild[];
  saleDate?: Date | null;
}

type DeedHistoryChild = Omit<DeedHistory, 'isActive' | 'isPriorSale' | 'children' | 'ListingId'>;

export enum HistoryType {
  listing = 'LISTING',
  deed = 'DEED',
}

export interface PriorSaleHistoryChange {
  history: ListingHistory[] | DeedHistory[];
  historyType: HistoryType;
}

export interface UpdatePropertyField {
  value: PropertyAttributeValue | undefined;
  key: keyof ExtendedPropertyDetail;
}

export interface UpdateStructureField {
  value: PropertyAttributeValue | undefined;
  key: StructureAttribute;
  structureIndex: number;
}

export interface UpdateUnitField {
  value: PropertyAttributeValue | undefined;
  key: UnitAttribute;
  structureIndex: number;
  unitIndex: number;
}

export interface ImageRecord {
  url: string;
  fileReferenceId?: string;
  automatedLabel: string | null;
  label: string | null;
  isSelected?: boolean;
  fileType: FileType;
  subCategory: string | null;
  createdDate: Date;
  updatedDate: Date;
  isInProgress?: boolean;
  description?: string;
  fileName?: string | null;
}

export interface GenerateListingSheetApiRequest {
  OrderId: string;
  MLSListingNumber?: string;
  MLSBoard?: string;
  Street?: string;
  Zip?: string;
}

export interface GenerateListingSheetApiResponse {
  Data?: {
    ReferenceId?: number;
  };
}

export interface Flood {
  isSFHA: boolean;
  FloodZone: string;
  FloodMapNumber: string;
  FIRMId: string;
  PanelId: string;
  CommunityName: string;
  CommunityId: string;
  floodMap?: string | null;
  FloodMapDate: string | null;
  PanelType: string | null;
}

export interface Plat {
  MajorDimensionsString: string;
  LotSizeSquareFeet: number;
  LotSizeAcres: number;
  LotShape: string;
  platMap: string;
}

export type SubjectPropertyFilter =
  | { scenarioId: string; isActive?: never; isSelected?: never }
  | { scenarioId?: never; isActive: boolean; isSelected?: never }
  | { scenarioId?: never; isActive?: never; isSelected: boolean };

export interface ImageEditDialogData {
  imageUrl: string | null;
  fileName: string;
  resizeToWidth?: number;
  outputMimeType?: string;

  /** Between 0 and 1. Applies to lossy formats such as JPEG only. */
  imageQuality?: number;
}

export interface ComparisonLayoutData {
  rows: ComparisonRow[];
  differences: number;
  incomplete: number;
  matches: number;
}

export interface ComparisonRow {
  field: PropertyPageViewField;
  config: PropertyFieldConfig;
  cells: {
    source: PropertyDataSourceType;
    missing: boolean;
    value: string | null;
  }[];
  different: boolean;
  incomplete: boolean;
}
